/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import zh from 'react-intl/locale-data/zh';
import i18n from 'lorai18n';
import config from 'loracfg';

addLocaleData(en);
addLocaleData(zh);

function chooseLocale() {
  if (config.language) {
    return config.language;
  }

  if (localStorage.getItem('language')) {
    switch (localStorage.getItem('language')) {
      case 'en': return 'en';
      case 'zh': return 'zh';
      default: return 'zh';
    }
  }

  switch (navigator.language.split('-')[0]) {
    case 'en': return 'en';
    case 'zh': return 'zh';
    default: return 'zh';
  }
}

const locale = chooseLocale();

// initial intl state
export default {
  locale,
  messages: i18n[locale],
};




// WEBPACK FOOTER //
// ./src/redux/store/intlState.js